import { Link } from "react-router-dom";
import { useState } from "react";
import api, { formatApiError } from "@/lib/api";

const LOGO_URL = "/media/img/capella-logo.png";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ loading: false, ok: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, ok: false, error: "" });
    try {
      await api.post("/leads/newsletter", {
        email, language: "tr", source_page: window.location.pathname, consent: true,
      });
      setStatus({ loading: false, ok: true, error: "" });
      setEmail("");
    } catch (err) {
      setStatus({ loading: false, ok: false, error: formatApiError(err.response?.data?.detail) || err.message });
    }
  };

  return (
    <footer className="bg-cc-dark text-cc-bg pt-24 pb-10 mt-32 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 relative">
        <div className="lg:col-span-5">
          <Link to="/" data-testid="footer-logo" className="inline-block mb-6">
            <img
              src={LOGO_URL}
              alt="Capella Cave"
              className="h-24 md:h-28 w-auto block"
            />
          </Link>
          <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/45 mb-7">Kapadokya · Açılış 2028</div>
          <h3 className="font-serif text-2xl md:text-3xl leading-tight mb-4 text-cc-bg">
            Kapadokya'nın hikâyesi,<br/>doğrudan kutunuza.
          </h3>
          <p className="text-cc-bg/70 text-sm leading-relaxed mb-7 max-w-md">
            Editör kalemiyle yazılmış rehberler, mevsimsel öneriler ve Capella Cave'in açılışına dair özel haberler.
            Ayda bir, gürültüsüz, özenle.
          </p>
          <form onSubmit={submit} className="flex items-center gap-3 border-b border-cc-bg/40 pb-2 max-w-md" data-testid="footer-newsletter-form">
            <input
              data-testid="footer-newsletter-email"
              required type="email"
              placeholder="E-posta adresiniz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent border-none outline-none text-cc-bg placeholder-cc-bg/45 py-2 text-sm"
            />
            <button
              data-testid="footer-newsletter-submit"
              type="submit" disabled={status.loading}
              className="text-[11px] tracking-[0.22em] uppercase text-cc-bg hover:text-cc-sepia transition disabled:opacity-50"
            >
              {status.loading ? "..." : "Bültene Katıl"}
            </button>
          </form>
          {status.ok && <p className="mt-3 text-xs text-cc-sepia" data-testid="footer-newsletter-ok">Teşekkürler — kutunuzu kontrol edin.</p>}
          {status.error && <p className="mt-3 text-xs text-red-300">{status.error}</p>}
        </div>

        <div className="lg:col-span-2">
          <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/45 mb-5">Keşfedin</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-cc-sepia transition" to="/kapadokya-rehberi">Kapadokya Rehberi</Link></li>
            <li><Link className="hover:text-cc-sepia transition" to="/kapadokya-gunlugu">Kapadokya Günlüğü</Link></li>
            <li><Link className="hover:text-cc-sepia transition" to="/capella-cave">Capella Cave</Link></li>
            <li><Link className="hover:text-cc-sepia transition" to="/kurucu-misafir-listesi">Kurucu Misafir</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/45 mb-5">Marka</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-cc-sepia transition" to="/sik-sorulan-sorular">Sık Sorulan Sorular</Link></li>
            <li><Link className="hover:text-cc-sepia transition" to="/iletisim">İletişim</Link></li>
            <li><Link className="hover:text-cc-sepia transition" to="/site-haritasi">Site Haritası</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/45 mb-5">Capella Cave</div>
          <p className="text-sm text-cc-bg/70 leading-relaxed">
            Göreme'nin kalbinde, asırlık tüfün içine oyulmuş 14 odalı butik bir mağara otel. Açılış 2028 ilkbaharı.
          </p>
          <Link to="/kurucu-misafir-listesi" className="inline-block mt-5 text-[11px] tracking-[0.22em] uppercase text-cc-bg hover:text-cc-sepia transition">
            Kurucu Misafir Listesi →
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20 pt-6 border-t border-cc-bg/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 relative">
        <p className="text-xs text-cc-bg/45">© {new Date().getFullYear()} Capella Cave. Tüm hakları saklıdır.</p>
        <div className="flex gap-6 text-xs text-cc-bg/45">
          <Link to="/gizlilik" className="hover:text-cc-sepia">Gizlilik</Link>
          <Link to="/kvkk" className="hover:text-cc-sepia">KVKK</Link>
          <Link to="/admin/login" className="hover:text-cc-sepia" data-testid="footer-admin-link">Yönetim</Link>
        </div>
      </div>
    </footer>
  );
}
